/* ProPlay engagement layer. Progressive enhancement only: every page works without it. */
(() => {
  if (window.__ppEngage) return;
  window.__ppEngage = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const RES_PATH = 'products/proplay-glove-pre-order-reservation';
  const store = {
    get(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
  };
  const clean = (s) => String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 16);
  const mainSection = () => document.querySelector('main > .shopify-section[id*="__main"]');
  const onView = (el, fn, threshold = 0.2) => {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      fn();
    }, { threshold });
    io.observe(el);
  };

  /* 1. Create My Glove: flash the parts that changed */
  function initBuilder() {
    for (const host of document.querySelectorAll('[data-gb-svg]')) {
      if (host.dataset.ppPop) continue;
      host.dataset.ppPop = '1';
      const snap = () => {
        const map = {};
        for (const part of host.querySelectorAll('[data-part]')) map[part.getAttribute('data-part')] = part.outerHTML.replace(/ class="[^"]*"/g, '');
        return map;
      };
      let prev = snap();
      new MutationObserver(() => {
        const now = snap();
        if (!reduce.matches) {
          for (const key of Object.keys(now)) {
            if (prev[key] !== undefined && prev[key] !== now[key]) host.querySelector(`[data-part="${key}"]`)?.classList.add('ppg-pop');
          }
        }
        prev = now;
      }).observe(host, { childList: true });
    }
  }

  /* 2. Find my glove: deal results like baseball cards with an honest fit score */
  function scoreCard(card, answer) {
    if (card.querySelector('.ppd-score')) return;
    let picks = 3; // sport, age group and throwing hand are always chosen
    if (answer.position && answer.position !== 'fielding') picks += 1;
    if (answer.breakin && answer.breakin !== 'any') picks += 1;
    if (answer.budget) picks += 1;
    const unconfirmed = card.querySelectorAll('.ppcx-warning').length;
    const confirmed = Math.max(0, picks - unconfirmed);
    const pct = Math.round((confirmed / picks) * 100);

    const badge = document.createElement('div');
    badge.className = 'ppd-score';
    badge.setAttribute('aria-hidden', 'true');
    const n = document.createElement('span');
    n.className = 'ppd-score-n';
    n.textContent = reduce.matches ? `${pct}%` : '0%';
    const l = document.createElement('span');
    l.className = 'ppd-score-l';
    l.textContent = 'Fit';
    badge.append(n, l);
    card.prepend(badge);

    const detail = document.createElement('span');
    detail.className = 'ppd-score-d';
    detail.textContent = `Fit score ${pct}% \u00b7 ${confirmed} of ${picks} of your picks confirmed`;
    const title = card.querySelector('h3');
    if (title) title.after(detail); else card.append(detail);

    if (!reduce.matches) {
      const start = performance.now();
      const run = (t) => {
        const k = Math.min(1, (t - start) / 900);
        n.textContent = `${Math.round(pct * (1 - Math.pow(1 - k, 3)))}%`;
        if (k < 1) requestAnimationFrame(run);
      };
      requestAnimationFrame(run);
    }
  }

  function initFinder() {
    for (const finder of document.querySelectorAll('proplay-game-finder')) {
      const results = finder.querySelector('[data-results]');
      const form = finder.querySelector('form');
      if (!results || !form || results.dataset.ppDeal) continue;
      results.dataset.ppDeal = '1';
      new MutationObserver(() => {
        const cards = [...results.querySelectorAll('.ppcx-card:not([data-dealt])')];
        if (!cards.length) return;
        const answer = Object.fromEntries(new FormData(form));
        cards.forEach((card, i) => {
          card.dataset.dealt = '1';
          card.classList.add('ppd-card');
          scoreCard(card, answer);
          if (reduce.matches) return;
          card.style.setProperty('--deal-i', String(i));
          card.style.setProperty('--deal-r', `${((i % 3) - 1) * 8}deg`);
          card.classList.add('ppd-deal');
        });
      }).observe(results, { childList: true, subtree: true });
    }
  }

  /* 3. Player photo wall: move into the borough band, rise in */
  function initWall() {
    const wall = document.querySelector('[data-ppw]');
    if (!wall || wall.dataset.ready) return;
    wall.dataset.ready = '1';
    const band = document.querySelector('.ppb-band .ppb-boroughs');
    if (band) band.after(wall);
    const items = [...wall.querySelectorAll('.ppw-item')];
    if (reduce.matches || !items.length) return;
    items.forEach((item, i) => {
      item.classList.add('ppw-in-wait');
      item.style.setProperty('--ppw-d', `${(i % 8) * 80}ms`);
    });
    onView(wall, () => items.forEach((item) => { item.classList.remove('ppw-in-wait'); item.classList.add('ppw-in'); }), 0.1);
  }

  /* 4. Glove loop video: place under the product, pause control, respect reduced motion */
  function initLoop() {
    const loop = document.querySelector('[data-ppl]');
    if (!loop || loop.dataset.ready) return;
    loop.dataset.ready = '1';
    const main = mainSection();
    if (main) main.after(loop);
    const video = loop.querySelector('video');
    const button = loop.querySelector('[data-ppl-toggle]');
    if (!video || !button) return;
    const sync = () => {
      button.textContent = video.paused ? 'Play' : 'Pause';
      button.setAttribute('aria-pressed', video.paused ? 'true' : 'false');
    };
    if (reduce.matches) { video.removeAttribute('autoplay'); video.pause(); }
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    button.addEventListener('click', () => { if (video.paused) video.play().catch(() => {}); else video.pause(); });
    sync();
  }

  /* 5. Referrals: capture ?ref, tag the cart, share panel */
  function myCode() {
    let code = clean(store.get('pp_my_ref'));
    if (!code) {
      const rand = (window.crypto && crypto.getRandomValues) ? crypto.getRandomValues(new Uint32Array(1))[0] : Math.floor(Math.random() * 4294967295);
      code = 'PP' + rand.toString(36).toUpperCase().padStart(6, '0').slice(-6);
      store.set('pp_my_ref', code);
    }
    return code;
  }

  async function tagCart(attributes) {
    const key = 'pp_cart_attrs';
    const json = JSON.stringify(attributes);
    try { if (sessionStorage.getItem(key) === json) return; } catch (e) {}
    try {
      const res = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
      });
      if (res.ok) { try { sessionStorage.setItem(key, json); } catch (e) {} }
    } catch (e) {}
  }

  function welcome() {
    if (location.pathname.indexOf(RES_PATH) !== -1) return;
    const bar = document.createElement('div');
    bar.className = 'ppref-toast';
    bar.setAttribute('role', 'status');
    const p = document.createElement('p');
    p.textContent = 'A teammate saved you a spot in the ProPlay lineup. ';
    const a = document.createElement('a');
    a.href = `${root}${RES_PATH}`;
    a.textContent = 'Reserve free \u2192';
    p.append(a);
    const close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Dismiss');
    close.textContent = '\u00d7';
    close.addEventListener('click', () => bar.remove());
    bar.append(p, close);
    document.body.append(bar);
    window.setTimeout(() => bar.remove(), 12000);
  }

  function initReferrals() {
    const fromUrl = clean(new URLSearchParams(location.search).get('ref'));
    const panel = document.querySelector('[data-ppref]');
    const mine = panel ? myCode() : clean(store.get('pp_my_ref'));
    let ref = fromUrl || clean(store.get('pp_ref'));
    if (ref && ref === mine) ref = '';
    if (fromUrl && ref) { store.set('pp_ref', ref); welcome(); }

    const attributes = {};
    if (ref) attributes['Referred by'] = ref;
    if (panel) attributes['My referral code'] = mine;
    if (Object.keys(attributes).length) tagCart(attributes);

    if (!panel || panel.dataset.ready) return;
    panel.dataset.ready = '1';
    const main = mainSection();
    if (main) main.after(panel);

    const url = new URL(panel.dataset.url, location.href);
    url.searchParams.set('ref', mine);
    const link = url.toString();
    const message = 'I reserved a ProPlay glove. Reserve yours free with my link and help me move up the lineup:';
    const input = panel.querySelector('[data-ppref-url]');
    const status = panel.querySelector('[data-ppref-status]');
    if (input) input.value = link;
    const sms = panel.querySelector('[data-ppref-sms]');
    if (sms) sms.href = `sms:?&body=${encodeURIComponent(`${message} ${link}`)}`;
    const mail = panel.querySelector('[data-ppref-mail]');
    if (mail) mail.href = `mailto:?subject=${encodeURIComponent('Reserve a ProPlay glove with me')}&body=${encodeURIComponent(`${message}\n\n${link}`)}`;

    panel.querySelector('[data-ppref-copy]')?.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(link); status.textContent = 'Link copied. Send it to your team.'; }
      catch (e) { input?.select(); status.textContent = 'Press Ctrl+C (or Cmd+C) to copy your link.'; }
    });
    const share = panel.querySelector('[data-ppref-share]');
    if (share && navigator.share) {
      share.hidden = false;
      share.addEventListener('click', () => navigator.share({ title: 'ProPlay glove reservation', text: message, url: link }).catch(() => {}));
    }
    if (reduce.matches) panel.classList.add('is-in');
    else onView(panel, () => panel.classList.add('is-in'));
  }

  function init() {
    initBuilder();
    initFinder();
    initWall();
    initLoop();
    initReferrals();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', () => { initBuilder(); initFinder(); initWall(); });
})();